<header>
  <app-head (newItemEvent)="addItem($event)" [titleModule]="'Booking Extension Requests'"></app-head>
</header>
<div class="row m-0">

  <!-- start sidebar  -->
  <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'Booking Extension Requests'"></app-sidebar>
  <!-- end sidebar  -->

  <!-- start content page  -->
  <main class="p-4 col-lg-10 ">
      <div class="d-md-flex justify-content-between align-items-center dashboard" style="margin-top: 6px; margin-bottom: 24px;">
          <p class="fw-bold ms-1" style="color: #6c6a6a;color: #6c6a6a;
        text-align: center;
        align-items: center;
        display: flex;
        justify-content: end;">Booking Extension Requests</p>

      </div>

      <p-toast></p-toast>
      <!----------------------------------------------------------------------->
      <!-- <div class="card">
          <div class="row d-flex justify-content-between align-items-center px-3">
             
              <div class="col-md-4">
                  <div class="d-flex mx-2 mt-4">
                      <p class="me-2 fs-5 fw-bold ml-8">Bookings Extension</p>
        
                  </div>
              </div>
            
              <div class="col-md-5 col-8">
                  <div class="input">
                      <input type="text" class="form-control py-2" placeholder=" Search Extension Booking" (keyup)="searchAction($event)"
                          [(ngModel)]="searchText" />
                      <img src="../../../assets/images/search.svg" alt="">
                  </div>
              </div>
          </div>
     

          <p-table class="table-shopping" [selectionPageOnly]="true" [tableStyle]="{'min-width': '50rem' ,'min-': '50rem'}"
              [value]="extensions">
              <ng-template pTemplate="header" class="text-center">
                  <tr>
                      <ng-container>


                          <th class="td-name">
                              Booking Code

                          </th>
                          <th class="td-name">
                              Tenant Name

                          </th>
                          <th class="td-name">
                              Apartment

                          </th>
                          <th class="td-name">
                              Extension Period

                          </th>
                          <th class="td-name">
                              Status

                          </th>
                          <th class="td-name">


                        </th>


                      </ng-container>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-exten>

                  <tr>



                      <td routerLink="/inquiries/view-inquire/{{ exten.booking_ID }}" style="cursor: pointer;
                      color: blue;
                      text-decoration: underline;
                  ">
                          {{ exten?.booking_Code }}
                      </td>
                      <td>
                          {{ exten?.guest_Name }}
                      </td>

                      <td>
                          {{ exten?.apartment }}
                      </td>
                      <td>
                        {{ exten?.extend_From }} - {{ exten?.extend_To }}
                    </td>
                      <td>
                          <div>
                              <span class="rounded-5 px-3 badge 	Pending" *ngIf="exten?.status=='InReview'">
                                  <span>
                                      <img src="assets/images/yallowDot.svg" alt="">
                                  </span>
                                  {{ exten?.status }}
                              </span>
                              <span class="rounded-5 px-3 badge 	Accepted" *ngIf="exten?.status=='Approved'">
                                  <span>
                                      <img src="assets/images/greenDot.svg" alt="">
                                  </span>
                                  {{ exten?.status }}
                              </span>
                              <span class="rounded-5 px-3 badge Rejected" *ngIf="exten?.status=='Rejected'">
                                  <span>
                                      <img src="assets/images/redDot.svg" alt="">
                                  </span>
                                  {{ exten?.status }}
                              </span>
                          </div>
                      </td>
                      <td>

                        <button class="btn btn-primary" style="border-radius: 10px; font-size: 14px;" (click)="ShowApproval(exten?.extend_ID)">Approval</button>

                      </td>



                  </tr>

              </ng-template>


              <ng-template pTemplate="emptymessage">
                  <div class="container text-center mt-4">
                      <p class="mb-0">No data found.</p>
                  </div>
              </ng-template>

          </p-table>
          <p-paginator *ngIf="numberextension > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
            [totalRecords]="totalRecords" [first]="first"></p-paginator>


      </div> -->
      <!-------------------------------------------update------------------------------------------------------------->
      

      <!-----------------------------------------------------------update----------------------------------------------------------------------------->
      <div>
        <div class="p-card p-3" style="border-radius: 16px;" >
          <div class="flex justify-content-between align-items-center mb-4" style="display: flex;">
            <!-- <h2>Subscription Alerts</h2> -->
             <!-- <div class="card-header">Users <span> {{numberTenants}} Users</span></div> -->
             <div class="d-flex mx-2 mt-4">
              <p class="me-2 fs-5 fw-bold ml-8">Bookings Extension</p>
              <p class="mb-3 bg-gray rounded-5 blue px-2 d-flex align-items-center">
                  {{totalRecords}} Extension
              </p>
          </div>
            <div class="p-inputgroup w-50" style=" position: relative;">
              <!-- <span class="p-inputgroup-addon">
                <i class="pi pi-search"></i>
              </span> -->
              <input type="text"  class="search-input" pInputText placeholder="      Search any Keywords" [(ngModel)]="globalFilter" (input)="dt2.filterGlobal(globalFilter, 'contains')" />
              <i class="pi pi-search search-icon"></i>
              <!-- <button pButton icon="pi pi-filter" class="p-button-outlined"></button> -->
               <!-- <img src="filterplan.svg" (click)="openFilterDialog()"   style="margin-left: 24px; cursor: pointer;"/> -->
            </div>
          </div>
        <!--[paginator]="true"  [rowsPerPageOptions]="[10, 25, 50]"  [rows]="5"-->
        <p-table
        #dt2
        [value]="extensions"
        dataKey="req_ID"


        *ngIf="tableReady"
        [paginator]="true" 
        [rows]="10"

       
        [first]="extensions.length > 0 ? currentPage : 0"
        (onPage)="onPageChange($event)"
           
        [rowsPerPageOptions]="[10, 20, 50]"
       
        
        
        
        [globalFilterFields]="['booking_Code',  'guest_Name', 'apartment','extend_From','extend_To','status'  ]"
        [tableStyle]="{ 'min-width': '75rem' }"

        [customSort]="true"
        (sortFunction)="customSort($event)"
    >
        <ng-template pTemplate="caption">
            <!-- <div class="flex">
                <p-iconField iconPosition="left" class="ml-auto">
                    <p-inputIcon>
                        <i class="pi pi-search"></i>
                    </p-inputIcon>
                    <input 
                        pInputText 
                        type="text" 
                        (input)="dt2.filterGlobal(globalFilter, 'contains')"
                        placeholder="Search keyword" />
                </p-iconField>
            </div> -->
        </ng-template>
        <ng-template pTemplate="header">
            <tr class="headOne">
                <!-- <th style="width:22%">booking ID</th> -->
                <th style="width:22%">Booking Code</th>
                <th style="width:22%"> Tenant Name</th>
                <th style="width:22%">Apartment</th>
                <th style="width:22%" pSortableColumn="extend_From">Extension From <p-sortIcon field="extend_From"></p-sortIcon> </th>
                <th style="width:22%" pSortableColumn="extend_To">Extension To <p-sortIcon field="extend_To"></p-sortIcon> </th> 
              
                <th style="width:22%">Status</th> 
                
                <th style="width:22%">Action</th>

            </tr>
            <tr>
                <th style="width:22%">
                    <p-columnFilter 
                        type="text" 
                        field="booking_Code" 
                        placeholder="Search by Code" 
                        ariaLabel="Filter Code" />
                </th>
                <th>
                    <p-columnFilter 
                        type="text" 
                        field="guest_Name" 
                        placeholder="Search by Name" 
                        ariaLabel="Filter Name" />
                </th>
                
                <th>
                  <p-columnFilter 
                  type="text" 
                  field="apartment" 
                  placeholder="Search by apartment" 
                  ariaLabel="Filter apartment" />
                </th>

                <th>
                  <p-columnFilter 
                  type="text" 
                  field="extend_From" 
                  placeholder="Search by extend_From" 
                  ariaLabel="Filter extend_From" />
                </th>

                <th>
                  <p-columnFilter 
                  type="text" 
                  field="extend_To" 
                  placeholder="Search by extend_To" 
                  ariaLabel="Filter extend_To" />
                </th>
               
                 
                
                  <th>
                    <p-columnFilter field="status" matchMode="equals" [showMenu]="false">
                      <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                        <p-dropdown 
                          [ngModel]="value" 
                          [options]="statuses"
                          optionLabel="label" 
                          optionValue="value"
                          (onChange)="filter($event.value)"  
                          placeholder="Select One" 
                          [showClear]="true">
                          <ng-template let-option pTemplate="item">
                            <p-tag 
                              [value]="option.label" 
                              [severity]="getSeverity(option.label)">
                            </p-tag>
                          </ng-template>
                        </p-dropdown>
                      </ng-template>
                    </p-columnFilter>
                  </th>

                 
                  
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-exten>
          <tr style="cursor: pointer;"  >

            <td routerLink="/inquiries/view-inquire/{{ exten.booking_ID }}" style="cursor: pointer;">
                {{ exten?.booking_Code }}
            </td>
            <td routerLink="/inquiries/view-inquire/{{ exten.booking_ID }}" style="cursor: pointer;">
                {{ exten?.guest_Name }}
            </td >

            <td routerLink="/inquiries/view-inquire/{{ exten.booking_ID }}" style="cursor: pointer;">
                {{ exten?.apartment }}
            </td>
            <td routerLink="/inquiries/view-inquire/{{ exten.booking_ID }}" style="cursor: pointer;">
              {{ exten?.extend_From }} 
          </td>
          <td routerLink="/inquiries/view-inquire/{{ exten.booking_ID }}" style="cursor: pointer;">
            {{ exten?.extend_To }}
          </td>
            <td style="cursor: pointer;">
                <div>
                    <span class="rounded-5 px-3 badge 	Pending" *ngIf="exten?.status=='InReview'">
                        <span>
                            <img src="assets/images/yallowDot.svg" alt="">
                        </span>
                        {{ exten?.status }}
                    </span>
                    <span class="rounded-5 px-3 badge 	Accepted" *ngIf="exten?.status=='Approved'">
                        <span>
                            <img src="assets/images/greenDot.svg" alt="">
                        </span>
                        {{ exten?.status }}
                    </span>
                    <span class="rounded-5 px-3 badge Rejected" *ngIf="exten?.status=='Rejected'">
                        <span>
                            <img src="assets/images/redDot.svg" alt="">
                        </span>
                        {{ exten?.status }}
                    </span>
                </div>
            </td>

                <td  >
                


                    <!----------------------------->
                    <div   class="flex justify-content-start align-items-center gap-3" style="display: flex;">
                        <!-- <div><img class="mr-2" style="cursor: pointer;" src="alertUser.svg"/></div> -->
                        <!-- <div class=" ">
                          <img
                          routerLink="/inquiries/view-inquire/{{ exten.booking_ID }}"
                            class="image-default"
                            src="assets/images/viewPay.svg"
                            alt="Default Alert Icon"
                            style="width: 32px; height: 32px;"
                            
                          />
                           
                        </div> -->

                        <img
                        routerLink="/inquiries/view-inquire/{{ exten.booking_ID }}"
                          class="image-default"
                          src="assets/images/viewPay.svg"
                          alt="Default Alert Icon"
                          style="width: 32px; height: 32px;"
                          
                        />
                      
                        <button class="btn btn-primary" style="border-radius: 10px; font-size: 14px;padding:5px;" (click)="ShowApproval(exten?.extend_ID)">Approval</button>
                        <button class="btn btn-primary" style="border-radius: 10px; font-size: 14px;padding:5px; background-color: #E3F2FD; color:#4790c4;" (click)=" open(exten?.extend_ID)">change date</button>

                        
                        <!-- <div  >
                          <img class="mr-2" style="cursor: pointer;" src="assets/images/threeDotPay.svg" (click)="op.toggle($event)" />
                        </div>
                        <p-overlayPanel #op>
                          <ul   class="menu-list list-unstyled">
                            <li><a      style="cursor: pointer; Color:#363636; text-decoration: none;"  
                              [routerLink]="['/checkout-inquire/checkout/',check.req_ID,check.userID]"
                              > View Details  </a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"    
                              (click)="goBookingDetails(check.req_ID ,check.userID)"> View Booking Details</a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"  (click)="GetBankDetails(check.req_ID)"> Show Bank Details</a></li>
                            <li><a   style="cursor: pointer; Color:#363636; text-decoration: none;"  (click)="GetRefundDetails(check.req_ID)"> Refund Process</a></li>

                            <li><a  style="cursor: pointer; Color:#363636; text-decoration: none;"  (click)="InsertCheckOut(check.req_ID,check.userID)"> Send Checkout Sheet</a></li>
                          
                          </ul>
                        
                         
                        </p-overlayPanel> -->
                      </div>
                
                </td>
 

            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No Data Found.</td>
            </tr>
        </ng-template>
</p-table>
<!-- 
	<p-paginator *ngIf="Inquires.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
							[totalRecords]="totalRecords" [first]="first"></p-paginator> -->

        </div>
        
      </div>
      <!---------------------------------------------------------------------------------------------------------------------------------------->

  </main>
  <!-- end content page  -->
</div>
<p-dialog header="Extension Approval" [modal]="true" [(visible)]="ShowApproval_Dialog" [style]="{ width: '40rem' }">
  <span class="p-text-secondary block mb-8">Take Decision for Extending Contract</span>
  <div class="col-12 col-md-12 mb-4 cards mt-3">


    <div>
      <input type="radio" name="drone" checked (change)="Reject_Input('hide')">

    <label class="fw-bold" style="color: #605D62; margin-left: 10px;"> Approved

       </label>
    </div>
   <div>
    <input type="radio" name="drone" (change)="Reject_Input('show')">

    <label class="fw-bold" style="color: #605D62; margin-left: 10px;" > Rejected

       </label>
   </div>



</div>
  <div class="flex items-center gap-4 mb-8" *ngIf="Show_Reject_Reason_Input==true">
    <label for="exampleInputSecuritydeposit" class="form-label gray fw-bold">Reject Reason</label>
    <textarea class="border p-3 pt-3 rounded-2 w-100" (change)="onTextChange($event)" [(ngModel)]="Extend_Reject_Reason" rows="3" style="resize: inherit"></textarea>
  </div>

  <div class="d-flex justify-content-between w-100">
    <a (click)="hideApproval()" style="    border: 1px solid;" class="backcancel text-decoration-none cursor bg-white rounded-2 py-2 px-3 fw-bold  xcvdd">
      Cancel
    </a>
    <button (click)="ExtensionApproval(Extend_ID,Extend_Approval,Extend_Reject_Reason)" class="rounded-2 text-white rounded-2 border-0 py-2 px-4" style="background-color: #1f4068 !important">
      confirm
    </button>

</div>
</p-dialog>


<!----------------changing extend date dialog----------------->
<!-- change-extension-dialog.component.html -->
<p-dialog header="Change Extension Date" [(visible)]="visible" [modal]="true" [style]="{ width: '400px',height:'400px' }">
  <div class="p-fluid">
    <div class="p-field my-4">
      <label for="date" style="padding-bottom: 10px;">New Extension Date</label>
      <p-calendar
        id="date"
        [(ngModel)]="selectedDate"
        dateFormat="yy-mm-dd"
        [showIcon]="true"
        inputId="dateInput"
      ></p-calendar>
    </div>

      <div class="d-flex justify-content-between w-100">
    <a (click)="close()" style="    border: 1px solid;" class="backcancel text-decoration-none cursor bg-white rounded-2 py-2 px-3 fw-bold  xcvdd">
      Cancel
    </a>
    <button (click)=" updateExtension()" class="rounded-2 text-white rounded-2 border-0 py-2 px-4" style="background-color: #1f4068 !important">
      confirm
    </button>

</div>
  </div>
</p-dialog>

